import React, {useState} from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { adminEditProfile } from "../services/editService";

//pass a user to the edit profile page.
const AdminEditProfileForm = (user) => { 
    const history = useHistory()
    const [updatedUser, setUpdatedUser] = useState('') 
    let[cpassword, csetPassword] = useState('')
    useEffect(() => {
        setUpdatedUser(user.user)
        csetPassword(user.user.password)
    }, [])
    
    const submitUser = () => {
        const editedUser = {...user.user, ...updatedUser};
        adminEditProfile(editedUser).then(status => history.push('/profile/admin'))
                                .catch((e) => {
                                    //console.log(e);
                                    alert("Issue while editing the data!")
                                    //Redirect to the profile page if there is an issue.
                                    //history.push('/profile')
                                })
    }
    
    return(
        <div className="row">
            <div className="col-3"></div>
        <div className=" wd-border-form col-7">
            <h2>Edit Profile</h2>
            <div className="form-group mt-5">
                <div className=" p-1 m-4">
                    <label htmlFor="name" className="form-label m-0" style={{color:"gray"}}>Name</label>
                    <input className="form-control wd-input p-0" name="name" onChange={e => setUpdatedUser((value) => ({...value,[e.target.name] : e.target.value}))} style={{color:"black"}} defaultValue={user.user.name} required>
                    </input>
                </div>
                <div className=" p-1 m-4">
                    <label htmlFor="email" className="form-label m-0" style={{color:"gray"}}>Email</label>
                    <input type="email" className="form-control wd-input p-0" name="email" onChange={e => setUpdatedUser((value) => ({...value,[e.target.name] : e.target.value}))}  
                    id="email" aria-describedby="email" style={{color:"black"}} defaultValue={user.user.email}>
                    </input>
                </div>

                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="userId" className="form-label m-0" style={{color:"gray"}}>UserId</label>
                    <input className="form-control wd-input p-0" name="userId"  
                    id="userId" aria-describedby="userId" style={{color:"black"}} value={user.user.userId} disabled>
                    </input>
                </div>

                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="location" className="form-label m-0" style={{color:"gray"}}>User Type</label>
                    <select className="form-select" defaultValue={user.user.uType} name="uType" onChange={e => setUpdatedUser((value) => ({...value,[e.target.name] : e.target.value}))}>
                        <option value="1" selected>Customer</option>
                        <option value="2">Restaurant Owner</option>
                        <option value="3">Admin</option>
                    </select>
                </div>

                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="website" className="form-label m-0" style={{color:"gray"}}>Password</label>
                    <input type="password" className="form-control wd-input p-0" name="password" onChange={e => setUpdatedUser((value) => ({...value,[e.target.name] : e.target.value}))}  
                    id="password" aria-describedby="website" style={{color:"black"}} name="password" defaultValue={user.user.password}>
                    </input>
                </div>
                <div className="wd-border-form p-1 m-4">
                    <label htmlFor="website" className="form-label m-0" style={{color:"gray"}}>Confirm Password</label>
                    <input type="password" className="form-control wd-input p-0" onChange={(event) =>
                        csetPassword(event.target.value)}  id="password" aria-describedby="website" style={{color:"black"}} defaultValue={user.user.password}>
                    </input>
                </div>
                <div className="wd-border-form p-1 m-4 mt-0">
                    {
                        updatedUser.password != cpassword && <label htmlFor="website" className="form-label m-0" style={{color:"red"}}>Passwords don't match</label>
                    }
                </div>
                <div>
                    {/*<Link to = "/login ">*/}
                        {
                            updatedUser.password == cpassword && <button className="btn btn-primary rounded-pill wd-register-button m-4" onClick={submitUser}> Edit </button>
                        }
                    {/*</Link>*/}
                        {
                            (updatedUser.password != cpassword) && <button className="btn btn-primary rounded-pill wd-register-button m-4" disabled> Edit </button>
                        }
                </div>
            </div>


        </div>
        <div className="col-2"></div>
        </div>

    )
}

export default AdminEditProfileForm;